export function numberWithCommas(x: any) {
  if (x === undefined || x === '') return x
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const formatCode = (text: string, start: number, end: number, concat = '...') => {
  if (!text) return text
  const total = start + end
  const length = text.length
  if (total >= length) {
    return text
  }
  return [text.slice(0, start), text.slice(length - end)].join(concat)
}

/**
 * Format a bigint or string (assumed base units) into a human-readable decimal string.
 * Equivalent to ethers' formatUnits.
 */
export function formatUnits(value: bigint | string, decimals: number): string {
  const bigValue = BigInt(value);
  const divisor = 10n ** BigInt(decimals);
  const whole = bigValue / divisor;
  const fraction = bigValue % divisor;

  const fractionStr = fraction.toString().padStart(decimals, '0').replace(/0+$/, '');

  return fractionStr ? `${whole}.${fractionStr}` : whole.toString();
}

/**
 * Parse a decimal string into base units as a bigint.
 * Equivalent to ethers' parseUnits.
 */
export function parseUnits(value: string, decimals: number): bigint {
  const [wholeStr, fractionStrRaw = ''] = value.split('.');

  if (!/^\d+$/.test(wholeStr) || (fractionStrRaw && !/^\d+$/.test(fractionStrRaw))) {
    throw new Error('Invalid decimal number format');
  }

  const fractionStr = fractionStrRaw.padEnd(decimals, '0').slice(0, decimals);
  const whole = BigInt(wholeStr);
  const fraction = BigInt(fractionStr || '0');

  return whole * 10n ** BigInt(decimals) + fraction;
}

export const renderValue = (value: any) => {
  if (!value) return '--'
  return value
}

export function toLocaleString(x) {
  return x.toLocaleString('fullwide', { useGrouping: false })
}

export function formatVietQRUrl({
  bankId,
  accountNo,
  template = "compact",
  amount,
  description,
  accountName,
}: {
  bankId: string;
  accountNo: string;
  template?: string;
  amount?: number | string;
  description?: string;
  accountName?: string;
}) {
  const baseUrl = `https://img.vietqr.io/image/${bankId}-${accountNo}-${template}.png`;

  const params = new URLSearchParams();

  if (amount) params.append("amount", amount.toString());
  if (description) params.append("addInfo", encodeURIComponent(description));
  if (accountName) params.append("accountName", encodeURIComponent(accountName));

  return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
}

export function toSentenceCase(str) {
  // Chuyển hết về chữ thường (với locale tiếng Việt để giữ dấu)
  const lower = str.toLocaleLowerCase('vi');
  // Viết hoa ký tự đầu và ghép với phần còn lại
  return lower.charAt(0).toLocaleUpperCase('vi') + lower.slice(1);
}